import Vue from 'vue';

let loading = null;

export default {
  show(options = {}) {
    if (loading) {
      return;
    }
    loading = Vue.prototype.$loading.show({
      ...{
        container: null,
        canCancel: false,
        transition: 'fade',
        color: '#43ab31',
        loader: 'dots',
        opacity: 0.3,
        zIndex: 9999,
      },
      ...options,
    });
  },

  hide: () => {
    if (loading) {
      loading.hide();
      loading = null;
    }
  },
};
